export const menuItems = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about-us' },
  { name: 'Menu', path: '/menu' },
  { name: 'Catering', path: '/catering' },
  // { name: 'Events', path: '/events' },
  // { name: 'Gallery', path: '/gallery' },
  { name: 'Contact', path: '/contact-us' },
];
